export default __webpack_public_path__ + "static/media/invadersLink1.00569771.png";